import { themes } from "ksc-portal-shareable-configs/dist/webpack/webpack-foundation/constants"

const { title } = document

export default (themes.filter((el) => el.title === title)[0] || { theme: "kr" })
  .theme
